import { render, staticRenderFns } from "./breakdown.vue?vue&type=template&id=4084fbe1&scoped=true"
import script from "./breakdown.vue?vue&type=script&lang=js"
export * from "./breakdown.vue?vue&type=script&lang=js"
import style0 from "./breakdown.vue?vue&type=style&index=0&id=4084fbe1&lang=scss&scoped=true"
import style1 from "./breakdown.vue?vue&type=style&index=1&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084fbe1",
  null
  
)

export default component.exports